import storage from 'shared/helpers/storage';
import { DEFAULT_STORE } from 'shared/helpers/storeUrl';

const SESSION_KEY = 'PDP_RECENTLY_VIEWED';
const MAX_RECENTLY_VIEWED_WIDGETS = 15;

export const getRecentViewedPDP = (): any[] => {
  let data: any[] = [];
  try {
    data = JSON.parse(storage.getItem<string>(SESSION_KEY, '') || '');
  } catch (err) {
    //do nothing
  }
  return data;
};

export const setRecentViewedPDP = (data: ProductDetail.IProduct[]) => {
  storage.setItem(SESSION_KEY, JSON.stringify(data.splice(0, MAX_RECENTLY_VIEWED_WIDGETS)));
};

export const removeRecentViewedPDP = (productID: string) => {
  const data = getRecentViewedPDP().filter((item) => item.id !== productID);
  setRecentViewedPDP(data);
};

export const getRecentViewedPDPByStore = (storeId: string) => {
  return getRecentViewedPDP().filter((item) =>
    (item.storeId ?? DEFAULT_STORE) === storeId
  );
};

export const addRecentViewedPDP = (data: ProductDetail.IProduct, storeId: string) => {
  const existingData = getRecentViewedPDP().filter((item) => item.id !== data.id);

  const { id, sku, title, subTitle, action_url, imageUrl } = data;

  setRecentViewedPDP([{ id, sku, title, subTitle, action_url, imageUrl, storeId }, ...existingData]);
};
